export default `Prefecture,Population
Aichi,7484094
Akita,1022839
Aomori,1308649
Chiba,6224027
Ehime,1385840
Fukui,787099
Fukuoka,5102871
Fukushima,1913606
Gifu,2032533
Gunma,1973476
Hiroshima,2844963
Hokkaido,5383579
Hyōgo,5536989
Ibaraki,2917857
Ishikawa,1154343
Iwate,1279814
Kagawa,976756
Kagoshima,1648752
Kanagawa,9127323
Kōchi,728461
Kumamoto,1786969
Kyoto,2610140
Mie,1815827
Miyagi,2334215
Miyazaki,1104377
Nagano,2099759
Nagasaki,1377780
Nara,1365008
Niigata,2305098
Ōita,1166729
Okayama,1922181
Okinawa,1434138
Osaka,8838908
Saga,833245
Saitama,7261271
Shiga,1413184
Shimane,694188
Shizuoka,3701181
Tochigi,1974671
Tokushima,756063
Tokyo,13513734
Tottori,573648
Toyama,1066883
Wakayama,963850
Yamagata,1122957
Yamaguchi,1405007
Yamanashi,835165`